module.exports = __webpack_public_path__ + "static/img/title_bg.81a0f56a.png";